import { render } from "./AppIcon.vue?vue&type=template&id=de351762"
import script from "./AppIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIcon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Ui/AppIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de351762"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de351762', __exports__)) {
    api.reload('de351762', __exports__)
  }
  
  module.hot.accept("./AppIcon.vue?vue&type=template&id=de351762", () => {
    api.rerender('de351762', render)
  })

}


export default __exports__